import { render, staticRenderFns } from "./BeerDetail.vue?vue&type=template&id=ac3aa8b2&scoped=true&lang=html&"
import script from "./BeerDetail.vue?vue&type=script&lang=js&"
export * from "./BeerDetail.vue?vue&type=script&lang=js&"
import style0 from "./BeerDetail.vue?vue&type=style&index=0&id=ac3aa8b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3aa8b2",
  null
  
)

export default component.exports